<div class="chat-devices-modal">
    <div class="chat-devices-modal__mobile-nav">
        <button class="chat-devices-modal__mobile-tab"
                type="button"
                [class.is-active]="activeMobilePanel === 'devices'"
                [attr.aria-pressed]="activeMobilePanel === 'devices'"
                (click)="setMobilePanel('devices')">
            Devices
        </button>
        <button class="chat-devices-modal__mobile-tab"
                type="button"
                [class.is-active]="activeMobilePanel === 'commands'"
                [attr.aria-pressed]="activeMobilePanel === 'commands'"
                [disabled]="!canOpenCommandsPanel"
                (click)="setMobilePanel('commands')">
            Commands
        </button>
        <button class="chat-devices-modal__mobile-tab"
                type="button"
                [class.is-active]="activeMobilePanel === 'details'"
                [attr.aria-pressed]="activeMobilePanel === 'details'"
                [disabled]="!canOpenDetailsPanel"
                (click)="setMobilePanel('details')">
            Details
        </button>
    </div>

    <div class="chat-devices-modal__grid">
        <section class="chat-devices-modal__panel" [class.is-mobile-active]="activeMobilePanel === 'devices'">
            <div class="chat-devices-modal__panel-heading">
                <div>
                    <span class="chat-devices-modal__eyebrow">Devices</span>
                    <h4 class="chat-devices-modal__panel-title">Registered devices</h4>
                </div>

                <div class="chat-devices-modal__panel-heading-actions">
                    <span class="chat-devices-modal__count">{{ devices.length }}</span>

                    <button class="chat-devices-modal__action-button"
                            type="button"
                            [class.is-active]="isAddDevicePopoverOpen"
                            (click)="onAddDeviceTriggerClick($event)">
                        <i class="fa-regular fa-plus"></i>
                        <span>Add device</span>
                    </button>
                </div>
            </div>

            <div class="chat-devices-modal__state" *ngIf="devicesLoading">Loading devices...</div>
            <div class="chat-devices-modal__state chat-devices-modal__state--error" *ngIf="!devicesLoading && devicesError">{{ devicesError }}</div>
            <div class="chat-devices-modal__state" *ngIf="!devicesLoading && !devicesError && devices.length === 0">
                {{ devicesEmptyMessage }}
            </div>

            <div class="chat-devices-modal__device-list" *ngIf="!devicesLoading && !devicesError && devices.length > 0">
                <button class="chat-devices-modal__device-card"
                        type="button"
                        *ngFor="let device of devices; trackBy: trackDeviceById"
                        [class.is-active]="selectedDeviceId === device.deviceId"
                        (click)="selectDevice(device)">
                    <div class="chat-devices-modal__device-top">
                        <div>
                            <div class="chat-devices-modal__device-title">{{ device.name }}</div>
                            <div class="chat-devices-modal__device-meta">
                                <span>{{ getDeviceTypeLabel(device) }}</span>
                                <span>{{ getDeviceCapabilityLabel(device) }}</span>
                                <span>{{ getDeviceVisibilityLabel(device) }}</span>
                            </div>
                        </div>

                        <span class="chat-devices-modal__status-pill"
                              [class.chat-devices-modal__status-pill--live]="getDeviceConnectionStatus(device) === 'live'">
                            {{ getDeviceConnectionStatus(device) === 'live' ? 'Live' : 'Offline' }}
                        </span>
                    </div>

                    <div class="chat-devices-modal__mini-grid">
                        <div>
                            <span class="chat-devices-modal__label">Device ID</span>
                            <span class="chat-devices-modal__value chat-devices-modal__value--mono">{{ device.deviceId }}</span>
                        </div>

                        <div>
                            <span class="chat-devices-modal__label">Last seen</span>
                            <span class="chat-devices-modal__value">
                                {{ getDeviceDate(device.lastSeenAt) ? (getDeviceDate(device.lastSeenAt) | date:'short') : 'Not recorded' }}
                            </span>
                        </div>
                    </div>
                </button>
            </div>
        </section>

        <section class="chat-devices-modal__panel" [class.is-mobile-active]="activeMobilePanel === 'commands'">
            <ng-container *ngIf="selectedDevice as device; else selectDeviceState">
                <button class="chat-devices-modal__mobile-back"
                        type="button"
                        (click)="setMobilePanel('devices')">
                    Back to devices
                </button>

                <div class="chat-devices-modal__panel-heading">
                    <div>
                        <span class="chat-devices-modal__eyebrow">Commands</span>
                        <h4 class="chat-devices-modal__panel-title">{{ device.name }}</h4>
                    </div>
                    <span class="chat-devices-modal__count">{{ deviceCommands.length }}</span>
                </div>

                <div class="chat-devices-modal__device-summary">
                    <span>{{ getDeviceTypeLabel(device) }}</span>
                    <span>{{ getDeviceCapabilityLabel(device) }}</span>
                    <span>{{ getDeviceDate(device.lastSeenAt) ? (getDeviceDate(device.lastSeenAt) | date:'short') : 'No heartbeat yet' }}</span>
                </div>

                <div class="chat-devices-modal__state" *ngIf="deviceCommandsLoading">Loading commands...</div>
                <div class="chat-devices-modal__state chat-devices-modal__state--error" *ngIf="!deviceCommandsLoading && deviceCommandsError">{{ deviceCommandsError }}</div>
                <div class="chat-devices-modal__state" *ngIf="!deviceCommandsLoading && !deviceCommandsError && deviceCommands.length === 0">
                    No commands have been recorded for this device yet.
                </div>

                <div class="chat-devices-modal__command-list" *ngIf="!deviceCommandsLoading && !deviceCommandsError && deviceCommands.length > 0">
                    <button class="chat-devices-modal__command-card"
                            type="button"
                            *ngFor="let command of deviceCommands; trackBy: trackDeviceCommandById"
                            [class.is-active]="selectedDeviceCommandId === command.commandId"
                            (click)="selectDeviceCommand(command)">
                        <div class="chat-devices-modal__command-top">
                            <span class="chat-devices-modal__command-title">{{ command.command }}</span>
                            <span class="chat-devices-modal__command-status"
                                  [class.chat-devices-modal__command-status--pending]="command.status === 'pending'"
                                  [class.chat-devices-modal__command-status--running]="command.status === 'running'"
                                  [class.chat-devices-modal__command-status--completed]="command.status === 'completed'"
                                  [class.chat-devices-modal__command-status--failed]="command.status === 'failed'"
                                  [class.chat-devices-modal__command-status--cancelled]="command.status === 'cancelled'">
                                {{ getDeviceCommandStatusLabel(command) }}
                            </span>
                        </div>

                        <div class="chat-devices-modal__command-meta">
                            <span>{{ command.commandType === 'terminal' ? 'Terminal' : 'Browser' }}</span>
                            <span>{{ getDeviceDate(command.time) ? (getDeviceDate(command.time) | date:'short') : 'No timestamp' }}</span>
                        </div>

                        <div class="chat-devices-modal__command-summary">{{ getDeviceCommandSummary(command) }}</div>
                    </button>
                </div>
            </ng-container>

            <ng-template #selectDeviceState>
                <div class="chat-devices-modal__state">Select a device to inspect its recent command history.</div>
            </ng-template>
        </section>

        <section class="chat-devices-modal__panel chat-devices-modal__panel--detail"
                 [class.is-mobile-active]="activeMobilePanel === 'details'">
            <ng-container *ngIf="selectedDeviceCommand as command; else noCommandSelectedState">
                <button class="chat-devices-modal__mobile-back"
                        type="button"
                        (click)="setMobilePanel('commands')">
                    Back to commands
                </button>

                <div class="chat-devices-modal__detail-header">
                    <div>
                        <h4 class="chat-devices-modal__panel-title">{{ command.command }}</h4>
                        <div class="chat-devices-modal__detail-meta">
                            <span>{{ command.commandType === 'terminal' ? 'Terminal command' : 'Browser command' }}</span>
                            <span>{{ getDeviceDate(command.time) ? (getDeviceDate(command.time) | date:'medium') : 'No timestamp' }}</span>
                        </div>
                    </div>

                    <span class="chat-devices-modal__command-status"
                          [class.chat-devices-modal__command-status--pending]="command.status === 'pending'"
                          [class.chat-devices-modal__command-status--running]="command.status === 'running'"
                          [class.chat-devices-modal__command-status--completed]="command.status === 'completed'"
                          [class.chat-devices-modal__command-status--failed]="command.status === 'failed'"
                          [class.chat-devices-modal__command-status--cancelled]="command.status === 'cancelled'">
                        {{ getDeviceCommandStatusLabel(command) }}
                    </span>
                </div>

                <div class="chat-devices-modal__feedback-tags" *ngIf="getDeviceCommandFeedbackTags(command).length > 0">
                    <span class="chat-devices-modal__feedback-tag"
                          *ngFor="let tag of getDeviceCommandFeedbackTags(command); trackBy: trackStringValue">
                        {{ tag }}
                    </span>
                </div>

                <div class="chat-devices-modal__detail-grid">
                    <div>
                        <span class="chat-devices-modal__label">Command ID</span>
                        <span class="chat-devices-modal__value chat-devices-modal__value--mono">{{ command.commandId }}</span>
                    </div>

                    <div>
                        <span class="chat-devices-modal__label">Requested by</span>
                        <span class="chat-devices-modal__value chat-devices-modal__value--mono">{{ command.requestedByUid || 'Not recorded' }}</span>
                    </div>

                    <div>
                        <span class="chat-devices-modal__label">Started</span>
                        <span class="chat-devices-modal__value">{{ getDeviceDate(command.startedAt) ? (getDeviceDate(command.startedAt) | date:'medium') : 'Pending' }}</span>
                    </div>

                    <div>
                        <span class="chat-devices-modal__label">Completed</span>
                        <span class="chat-devices-modal__value">{{ getDeviceDate(command.completedAt) ? (getDeviceDate(command.completedAt) | date:'medium') : 'Pending' }}</span>
                    </div>

                    <div *ngIf="getDeviceCommandRunner(command) as runner">
                        <span class="chat-devices-modal__label">Runner</span>
                        <span class="chat-devices-modal__value">{{ runner }}</span>
                    </div>

                    <div *ngIf="getDeviceCommandExecutionMetadata(command) as execution">
                        <span class="chat-devices-modal__label">Attempts</span>
                        <span class="chat-devices-modal__value">{{ execution.attemptCount || 0 }} / {{ execution.maxAttempts || 1 }}</span>
                    </div>

                    <div class="chat-devices-modal__detail-grid-item chat-devices-modal__detail-grid-item--full">
                        <span class="chat-devices-modal__label">Result summary</span>
                        <span class="chat-devices-modal__value">{{ getDeviceCommandSummary(command) }}</span>
                    </div>
                </div>

                <div class="chat-devices-modal__structured-grid">
                    <div class="chat-devices-modal__structured-card">
                        <span class="chat-devices-modal__label">Payload</span>
                        <pre>{{ formatDeviceCommandValue(command.payload) }}</pre>
                    </div>

                    <div class="chat-devices-modal__structured-card">
                        <span class="chat-devices-modal__label">Requested feedback</span>
                        <pre>{{ formatDeviceCommandValue(command.requestedFeedback) }}</pre>
                    </div>
                </div>

                <div class="chat-devices-modal__execution-block" *ngIf="command.commandType === 'terminal'">
                    <div class="chat-devices-modal__detail-grid">
                        <div>
                            <span class="chat-devices-modal__label">Exit code</span>
                            <span class="chat-devices-modal__value">{{ command.feedback?.terminal?.exitCode ?? 'Pending' }}</span>
                        </div>

                        <div>
                            <span class="chat-devices-modal__label">Error</span>
                            <span class="chat-devices-modal__value">{{ command.error || 'None' }}</span>
                        </div>

                        <div *ngIf="getDeviceCommandExecutionStrategyLabel(command) as retryStrategy">
                            <span class="chat-devices-modal__label">Retry policy</span>
                            <span class="chat-devices-modal__value">{{ retryStrategy }}</span>
                        </div>

                        <div *ngIf="getDeviceCommandTotalOutputCharacters(command) as totalCharacters">
                            <span class="chat-devices-modal__label">Output size</span>
                            <span class="chat-devices-modal__value">{{ totalCharacters | number }} characters</span>
                        </div>
                    </div>

                    <div class="chat-devices-modal__structured-card chat-devices-modal__structured-card--terminal-shell">
                        <div class="chat-devices-modal__structured-card-head">
                            <span class="chat-devices-modal__label">Terminal output</span>
                            <span class="chat-devices-modal__structured-card-note"
                                  *ngIf="isDeviceCommandOutputTruncated(command)">
                                Stored output was truncated
                            </span>
                        </div>

                        <app-chat-device-command-terminal
                            [lightMode]="theme.isLight"
                            [liveOutput]="selectedDeviceCommandLiveOutput$ | async"
                            [storedOutput]="command.feedback?.terminal?.stdout || ''">
                        </app-chat-device-command-terminal>

                        <p class="chat-devices-modal__execution-note"
                           *ngIf="isDeviceCommandOutputTruncated(command) && getDeviceCommandTotalOutputCharacters(command) as totalCharacters">
                            The stored terminal transcript was truncated after {{ totalCharacters | number }} captured characters.
                        </p>
                    </div>

                    <div class="chat-devices-modal__structured-card"
                         *ngIf="command.feedback?.terminal?.stderr || command.error">
                        <span class="chat-devices-modal__label">Error output</span>
                        <pre>{{ command.feedback?.terminal?.stderr || command.error }}</pre>
                    </div>
                </div>

                <div class="chat-devices-modal__execution-block" *ngIf="command.commandType === 'browser'">
                    <div class="chat-devices-modal__detail-grid">
                        <div>
                            <span class="chat-devices-modal__label">Page URL</span>
                            <span class="chat-devices-modal__value chat-devices-modal__value--mono">{{ command.feedback?.browser?.url || 'Not captured' }}</span>
                        </div>

                        <div>
                            <span class="chat-devices-modal__label">Page title</span>
                            <span class="chat-devices-modal__value">{{ command.feedback?.browser?.title || 'Not captured' }}</span>
                        </div>

                        <div *ngIf="getDeviceCommandBrowserTabId(command) as tabId">
                            <span class="chat-devices-modal__label">Browser tab</span>
                            <span class="chat-devices-modal__value">{{ tabId }}</span>
                        </div>
                    </div>

                    <div class="chat-devices-modal__structured-card chat-devices-modal__structured-card--media"
                         *ngIf="getDeviceCommandBrowserScreenshot(command) as screenshotSource">
                        <div class="chat-devices-modal__structured-card-head">
                            <span class="chat-devices-modal__label">Screenshot</span>
                            <span class="chat-devices-modal__structured-card-note">Captured browser state</span>
                        </div>
                        <img [src]="screenshotSource"
                             alt="Browser command screenshot"
                             class="chat-devices-modal__browser-screenshot" />
                    </div>

                    <div class="chat-devices-modal__structured-card chat-devices-modal__structured-card--placeholder"
                         *ngIf="!getDeviceCommandBrowserScreenshot(command)">
                        <span class="chat-devices-modal__label">Screenshot</span>
                        <p class="chat-devices-modal__execution-note">No screenshot was captured for this browser command.</p>
                    </div>

                    <div class="chat-devices-modal__structured-grid">
                        <div class="chat-devices-modal__structured-card">
                            <span class="chat-devices-modal__label">Extracted text</span>
                            <pre>{{ command.feedback?.browser?.text || 'No visible text was captured.' }}</pre>
                        </div>

                        <div class="chat-devices-modal__structured-card">
                            <span class="chat-devices-modal__label">HTML snapshot</span>
                            <pre>{{ command.feedback?.browser?.html || 'No HTML snapshot was captured.' }}</pre>
                        </div>
                    </div>
                </div>

                <div class="chat-devices-modal__structured-card"
                     *ngIf="getDeviceCommandFeedbackWarnings(command).length > 0">
                    <span class="chat-devices-modal__label">Feedback warnings</span>
                    <div class="chat-devices-modal__warning-list">
                        <div class="chat-devices-modal__warning-item"
                             *ngFor="let warning of getDeviceCommandFeedbackWarnings(command); trackBy: trackStringValue">
                            {{ warning }}
                        </div>
                    </div>
                </div>

                <div class="chat-devices-modal__structured-card"
                     *ngIf="getDeviceCommandExecutionAttempts(command).length > 0">
                    <span class="chat-devices-modal__label">Execution history</span>
                    <div class="chat-devices-modal__attempt-list">
                        <div class="chat-devices-modal__attempt-card"
                             *ngFor="let attempt of getDeviceCommandExecutionAttempts(command); trackBy: trackExecutionAttempt">
                            <div class="chat-devices-modal__attempt-top">
                                <span class="chat-devices-modal__attempt-title">Attempt {{ attempt.attempt }}</span>
                                <span class="chat-devices-modal__command-status"
                                      [class.chat-devices-modal__command-status--completed]="attempt.status === 'completed'"
                                      [class.chat-devices-modal__command-status--failed]="attempt.status === 'failed'">
                                    {{ attempt.status === 'completed' ? 'Completed' : 'Failed' }}
                                </span>
                            </div>

                            <div class="chat-devices-modal__attempt-meta">
                                <span>Started {{ getDeviceDate(attempt.startedAt) ? (getDeviceDate(attempt.startedAt) | date:'short') : attempt.startedAt }}</span>
                                <span>Finished {{ getDeviceDate(attempt.completedAt) ? (getDeviceDate(attempt.completedAt) | date:'short') : attempt.completedAt }}</span>
                                <span *ngIf="attempt.exitCode !== undefined && attempt.exitCode !== null">Exit {{ attempt.exitCode }}</span>
                                <span>{{ attempt.retryable ? 'Retryable' : 'Final' }}</span>
                            </div>

                            <div class="chat-devices-modal__attempt-summary">{{ attempt.summary }}</div>
                            <div class="chat-devices-modal__attempt-error" *ngIf="attempt.error">{{ attempt.error }}</div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-template #noCommandSelectedState>
                <div class="chat-devices-modal__state">Select a command to inspect its execution details.</div>
            </ng-template>
        </section>
    </div>

    <ng-template #addDevicePopoverTemplate>
        <div class="chat-devices-modal__add-device-popover" (click)="$event.stopPropagation()">
            <div class="chat-devices-modal__setup-heading">
                <div>
                    <span class="chat-devices-modal__eyebrow">Add device</span>
                    <h4 class="chat-devices-modal__panel-title">Register a computer or request browser access</h4>
                    <p class="chat-devices-modal__popover-subtitle">Use the desktop app for terminal access, or request Chrome extension access for browser automation.</p>
                </div>
                <span class="chat-devices-modal__setup-badge"
                      [class.chat-devices-modal__setup-badge--ready]="isElectronDesktop">
                    {{ isElectronDesktop ? 'Desktop ready' : 'Web chat' }}
                </span>
            </div>

            <div class="chat-devices-modal__setup-grid">
                <article class="chat-devices-modal__setup-card">
                    <div class="chat-devices-modal__setup-card-heading">
                        <span class="chat-devices-modal__setup-title">Computer</span>
                        <span class="chat-devices-modal__setup-chip">Terminal</span>
                    </div>

                    <p class="chat-devices-modal__setup-note">
                        {{ isElectronDesktop
                            ? getDesktopRegistrationNote()
                            : 'Computer setup only works in the Platfio desktop app.' }}
                    </p>

                    <div class="chat-devices-modal__setup-form" *ngIf="isElectronDesktop; else desktopUnavailableState">
                        <label class="chat-devices-modal__input-label" for="chat-device-name">Computer name</label>
                        <input id="chat-device-name"
                               class="chat-devices-modal__text-input"
                               type="text"
                               [(ngModel)]="desktopDeviceName"
                               [disabled]="registeringDesktopDevice"
                               placeholder="My Mac Desktop" />

                           <ui-form-field type="toggle"
                                    label="Share this device with everyone in the agency"
                                    toggleLabel="Everyone"
                                    toggleLabelOff="Only me"
                                    [(ngModel)]="desktopDeviceAgencyShared"
                                    [disabled]="registeringDesktopDevice">
                           </ui-form-field>

                        <div class="chat-devices-modal__setup-actions">
                            <ui-button variant="outline"
                                       color="primary"
                                       size="sm"
                                       icon="fa-regular fa-desktop"
                                       [disabled]="registeringDesktopDevice || !desktopDeviceName.trim() || !isAuthenticated"
                                       (buttonClick)="registerDesktopDevice()">
                                {{ registeringDesktopDevice ? 'Saving...' : desktopRegistrationActionLabel }}
                            </ui-button>
                            <span class="chat-devices-modal__setup-hint">This desktop app instance will be saved to your account.</span>
                        </div>
                    </div>

                    <ng-template #desktopUnavailableState>
                        <p class="chat-devices-modal__setup-hint">Open this chat in the Platfio desktop app to register a computer.</p>
                    </ng-template>
                </article>

                <article class="chat-devices-modal__setup-card">
                    <div class="chat-devices-modal__setup-card-heading">
                        <span class="chat-devices-modal__setup-title">Browser</span>
                        <span class="chat-devices-modal__setup-chip">Chrome extension</span>
                    </div>

                    <p class="chat-devices-modal__setup-note">
                        Browser automation is available through the Platfio Chrome extension beta.
                    </p>

                    <div class="chat-devices-modal__setup-actions">
                        <ui-button variant="outline"
                                   color="gray"
                                   size="sm"
                                   icon="fa-regular fa-envelope"
                                   (buttonClick)="openBrowserAccessRequest()">
                            Apply for Access
                        </ui-button>
                    </div>
                </article>
            </div>
        </div>
    </ng-template>
</div>